import {SELECTED_CABINET_COLOR} from 'components/customer/Preview3D/helpers/Three';

/**
 * Look of the wall-distance "pill" labels shown in reposition mode. Shared by
 * the canvas sprite (createRoomObjects) and the inline editor that replaces
 * it while the user types (DistanceBubbleEditor), so both match.
 *
 * Sizes are canvas pixels; the canvas is drawn at twice its on-screen size.
 */
export const DISTANCE_LABEL_STYLE = {
    canvasHeight: 58,
    // On-screen height in world units (the sprite's scale.y).
    spriteHeight: 29,
    // Zoom while hovered (and kept while its number is being edited).
    hoverScale: 1.6,
    hoverDurationMs: 150,
    paddingX: 42,
    radius: 16,
    borderWidth: 4,
    fontSize: 30,
    fontWeight: 600,
    fontFamily: '"SFMono-Regular", Menlo, Consolas, monospace',
    fill: '#F6F4EE',
    // Matches the selected cabinet's selection box.
    border: SELECTED_CABINET_COLOR,
    text: '#111A19',
} as const;
